"use client";

import type { Destination } from "@/app/utils/destinations/destinationData";
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useTranslations } from "next-intl";

const PlaceSection = ({
  destinations,
  setDestination,
}: {
  destinations: Destination[];
  setDestination?: (val: Destination) => void;
}) => {
  const t = useTranslations();
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardWidth = 282;

  return (
    <section className="w-full md:py-10 py-6 px-4 bgmd:px-0 text-sleap-gray-950 dark:text-white m-0">
      <div className="container mx-auto">
        <h3 className="text-sleap-gray-950 dark:text-white text-[28px] leading-7 font-switzer font-bold md:mb-6 mb-4">
          {t("HomePage.topCityDestinations")}
        </h3>
        <div className="flex flex-col items-center gap-6 w-full overflow-hidden relative">
          <Swiper
            modules={[Autoplay]}
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            speed={9000}
            slidesPerView="auto"
            spaceBetween={24}
            grabCursor={!isMobile}
            className="!w-full"
          >
            {[...destinations, ...destinations].map((card, index) => (
              <SwiperSlide
                key={`${card.name}-${index}`}
                style={{ width: `${cardWidth}px`, flexShrink: 0 }}
              >
                <div
                  className="bg-white dark:bg-sleap-gray-950 border border-sleap-gray-400 dark:border-sleap-gray-600 rounded-2xl cursor-pointer"
                  onClick={() => {
                    if (setDestination) {
                      setDestination(card);
                    }
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  <div className="w-[282px] h-[248px] rounded-t-lg">
                    <img
                      className="w-full h-full object-cover rounded-t-2xl"
                      src={"image" in card ? card.image : ""}
                      alt={t("Other.visitName", { name: card.name })}
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <h4 className="text-sleap-gray-950 dark:text-white text-2xl font-switzer font-bold mb-0">
                      {card.name}
                    </h4>
                    <span className="text-sm font-medium font-switzer text-sleap-purple-300 mt-4">
                      {t("Other.hotelsCount", { count: card.hotels })}
                    </span>
                    <p className="text-sleap-gray-950 dark:text-white text-sm opacity-50 font-switzer font-medium mb-0 mt-2 line-clamp-2">
                      {card.description}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default PlaceSection;
